import { ItemImage } from 'components/Item/Image.js'
import React from 'react'
import Link from 'components/Link'

/**
 * @param image
 * @param isHorizontal
 * @param width
 * @param title
 * @param url
 * @param shouldLazyLoad
 * @returns {JSX.Element}
 * @constructor
 */
export function ListRowItemImage ({
  image,
  isHorizontal,
  width,
  title,
  shouldLazyLoad,
  url
}) {
  const aspectRatio = isHorizontal
    ? ItemImage.ASPECT_RATIO.WIDE
    : ItemImage.ASPECT_RATIO.TALL
  return (
    <Link
      to={url}
      title={title}
      style={{
        display: 'block'
      }}
    >
      <ItemImage
        source={image}
        title={title}
        aspectRatio={aspectRatio}
        width={width}
        shouldLazyLoad={shouldLazyLoad}
      />
    </Link>
  )
}
